import BLE_UUID_TYPES from "../../consts/bleUuidTypes";
import ledMode from "../../consts/ledMode";
import { buffer2hexArr } from "../../utils/utils";
import BleService from "../ble/BleService";
import scpService from "../scp/scpService";
import * as scp from "../../consts/scpConsts";
import FrameProcessingService from "./frameProcessingService";

const connect = async (deviceId) => {
    const deviceService = new BleService();
    const deviceClient = deviceService.getDevice(deviceId);
    let frameProcessingService;

    try {
        await deviceClient.connect();
        await deviceClient.getServices();
        frameProcessingService = new FrameProcessingService(deviceId, true);
    } catch (error) {
        deviceClient.disconnect();
        frameProcessingService.stop();
    }
};

const subscribeOnCharacteristic = async (deviceId, characteristicType, callback) => {
    const deviceService = new BleService();
    const deviceClient = deviceService.getDevice(deviceId);

    const characteristic = await deviceClient.getCharacteristic(
        BLE_UUID_TYPES.RRP_SERVICE,
        characteristicType
    );
    characteristic.subscribeOnMessage(callback);
};

const unsubscribeOnCharacteristic = async (deviceId, characteristicType, callback) => {
    const deviceService = new BleService();
    const deviceClient = deviceService.getDevice(deviceId);

    const characteristic = await deviceClient.getCharacteristic(
        BLE_UUID_TYPES.RRP_SERVICE,
        characteristicType
    );

    characteristic.unsubscribeOnMessage(callback);
};

const disconnect = async (deviceId) => {
    const deviceService = new BleService();
    const deviceClient = deviceService.getDevice(deviceId);
    await deviceClient.disconnect();
    new FrameProcessingService(deviceId)?.stop();
};

const initDevice = async (deviceId) => await scpService.identifyDevice(deviceId);

const reconnect = async (deviceId) => {
    const deviceService = new BleService();
    const deviceClient = deviceService.getDevice(deviceId);
    let frameProcessingService;

    try {
        await deviceClient.getServices();
        frameProcessingService = new FrameProcessingService(deviceId, true);
    } catch (error) {
        deviceClient.disconnect();
        frameProcessingService.stop();
    }
};

const setVibration = (deviceId, state) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: state ? scp.FRAME_START_VIBRATION : scp.FRAME_STOP_VIBRATION,
            onResponse: (frame) => {
                const frameConverted = scpService.mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej("Error set vibration");
                } else {
                    res();
                }
            },
            onError: (err) => rej(err),
        });
    });
};

const setLedSettings = (deviceId, mode) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: mode === ledMode.DAY ? scp.FRAME_LED_DAY: scp.FRAME_LED_NIGHT,
            onResponse: (frame) => {
                const frameConverted = scpService.mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej("Error set led");
                } else {
                    res();
                }
            },
            onError: (err) => rej(err),
        });
    });
};

const getLedSettings = (deviceId) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: scp.FRAME_LED_SETTINGS,
            onResponse: (frame) => {
                const frameConverted = scpService.mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej("Error get led");
                } else {
                    const led = frameConverted.payload[0];

                    res(led === 0x0e ? ledMode.NIGHT : ledMode.DAY);
                }
            },
            onError: (err) => rej(err),
        });
    });
};

const deviceService = {
    connect,
    disconnect,
    reconnect,
    initDevice,
    setLedSettings,
    getLedSettings,
    setVibration,
    subscribeOnCharacteristic,
    unsubscribeOnCharacteristic,
};

export default deviceService;
